import React, { useState } from "react";
import rightArrowWhiteSvg from "assets/translation-services/right-arrow-white.svg";
import rightArrowBlackSvg from "assets/translation-services/right-arrow-black.svg";
import Text from "components/Text";
import QuotePopUp from "components/popup/quotePopUp/index";
import OptimizedImage from "hooks/OptimizedImage";
import { Link } from "gatsby";

function TwoCol({
  data,
  background = "bg-white",
  order = "order-last",
  isBanner = false,
}) {
  const [open, setOpen] = useState(false);
  return (
    <div
      className={`px-4 2xl:px-0 lg:py-28 ${
        isBanner ? "py-10" : "py-20"
      } ${background} ${data.isHero && "lg:py-0 lg:pt-24 lg:pb-12"} ${
        data.paddingBottom && "lg:pb-0"
      }`}
    >
      <div className="w-full max-w-7xl mx-auto">
        <div className="lg:grid grid-cols-2 items-center gap-28">
          <div>
            {data.subTitle ? (
              <Text
                as="h2"
                highlightedText={data?.subTitleHighlightWords}
                highlightedColor={data?.subTitleHighlightedColor}
                className="text-base lg:text-26 review_title xs:font-secondary font-semibold pb-3"
              >
                {data.subTitle}
              </Text>
            ) : null}
            <Text
              as={data?.titleTag ? data.titleTag : "h3"}
              highlightedText={data?.highlightWords}
              highlightedColor={data?.highlightedColor}
              className="text-45 leading-[55px] text-black xs:font-secondary dsfdsfds font-bold pb-6"
            >
              {data.title}
            </Text>
            <Text
              as="p"
              className={`text-lg leading-8 text-[#3D3F42] font-opensans ${
                data.cta3 && "pb-6"
              }`}
            >
              {data.description}
            </Text>
            <div
              className={`${
                data.cta2
                  ? "flex flex-col sm:flex-row sm:items-center gap-6"
                  : " "
              } ${data.cta ? "pt-6" : data.cta2 ? "pt-6" : " "}`}
            >
              {data.cta ? (
                <Text
                  as={data.cta.link ? "a" : "button"}
                  href={data.cta.link ? data.cta.link : ""}
                  className="text-base text-white bg-[#ff7b16] font-opensans font-semibold uppercase cursor-pointer rounded-full border-2 border-transparent py-5 lg:px-14 w-60 lg:w-auto bg-transparent inline-flex items-center justify-center gap-2 mt-4 lg:mt-7"
                >
                  {data.cta.title}
                  <img src={rightArrowWhiteSvg} alt="cta" />
                </Text>
              ) : null}
              {data.cta2 ? (
                <Text
                  as={data.cta2.link ? "a" : "button"}
                  href={data.cta2.link ? data.cta2.link : ""}
                  className="text-base text-black font-opensans font-semibold uppercase cursor-pointer rounded-full border-2 border-black py-5 px-14 bg-transparent inline-flex items-center justify-center gap-2 mt-2 lg:mt-7 w-60 lg:w-auto"
                  onClick={() => setOpen(true)}
                >
                  {data.cta2.title}
                  <img src={rightArrowBlackSvg} alt="cta" />
                </Text>
              ) : null}
              {data.cta3 ? (
                <Link
                  to={data.cta3.href}
                  className="text-base bg-gradient-to-r from-[#F93443] to-[#FF6E1F] text-20 xs:font-secondary font-semibold underline pb-2 inline-block text-transparent bg-clip-text  decoration-sky-500"
                >
                  {/* <p> {item.cta.title}</p> */}
                  <div className="gradient-underline">
                    {data.cta3.title} &#x2192;
                  </div>
                </Link>
              ) : null}
            </div>
            {data.isHero && (
              <div className="space-y-8 mt-12">
                <p className="text-center lg:text-left">
                  Trusted by Satisfied Clients Worldwide
                </p>
                <div className="lg:flex items-center gap-8">
                  <div className="flex items-center justify-center gap-8">
                    <OptimizedImage
                      src="https://tomedes.gumlet.io/assets/clients/amazon.svg"
                      alt="amazon"
                      className="w-24 h-auto"
                    />
                    <OptimizedImage
                      src="https://tomedes.gumlet.io/assets/clients/google.svg"
                      alt="google"
                      className="w-20 h-auto"
                    />
                    <OptimizedImage
                      src="https://tomedes.gumlet.io/assets/clients/microsoft.svg"
                      alt="microsoft"
                      className="w-24 h-auto"
                    />
                  </div>
                  <div className="flex mt-8 lg:mt-0 items-center justify-center gap-8">
                    <OptimizedImage
                      src="https://tomedes.gumlet.io/assets/clients/wix.svg"
                      alt="wix"
                      className="w-20 h-auto"
                    />
                    <OptimizedImage
                      src="https://tomedes.gumlet.io/assets/clients/bloomberg.svg"
                      alt="bloomberg"
                      className="w-24 h-auto"
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className={`hidden lg:block ${order}`}>
            <img src={data.img} alt={data.isHero ? data.title :!data.subTitle ? data.title : data.subTitle} className="w-full max-w-full" />
          </div>
        </div>
      </div>
      {data.isHero && (
        <ul className="flex lg:flex-row flex-col text-black sm:justify-between lg:mx-auto  xl:justify-evenly pt-20 gap-x-10 lg:gap-y-0 gap-y-8 mt-7">
          <li className="flex justify-center mt-6 lg:mt-0 items-center">
            <OptimizedImage
              src="https://tomedes.gumlet.io/assets/images/new-homepage-assets/desktop/call-center.svg"
              alt="Available Online 24/7"
              className="w-[53px] lg:w-[40px] h-[53px] lg:h-[40px]"
            />
            <p className="text-[20px] font-semibold pl-4 lg:text-left text-center">
              Available Online 24/7
            </p>
          </li>
          <li className="flex justify-center items-center">
            <OptimizedImage
              src="https://tomedes.gumlet.io/assets/images/new-homepage-assets/desktop/badge.svg"
              alt="1-Year Guarantee"
              className="w-[53px] lg:w-[40px] h-[70px] lg:h-[52px]"
            />
            <p className="text-[20px] font-semibold pl-4 lg:text-left text-center">
              1-Year Guarantee
            </p>
          </li>
          <li className="flex justify-center items-center">
            <OptimizedImage
              src="https://tomedes.gumlet.io/assets/images/new-homepage-assets/desktop/Group.svg"
              alt="95,000 Business Customers"
              className="w-[53px] lg:w-[40px] h-11 lg:h-8"
            />
            <p className="text-[20px] font-semibold pl-4 lg:text-left text-center">
              95,000 Business Customers
            </p>
          </li>
        </ul>
      )}
      <QuotePopUp open={open} setOpen={setOpen} />
    </div>
  );
}
export default TwoCol;
